import { ExternalConnection, ID } from '@griply/types';

export type NewExternalConnectionsResult = {
  newConnections: ExternalConnection[];
  nextTrackedIds: ID[];
};

// null trackedIds = uninitialised: seed with current ids and emit nothing, so pre-existing connections aren't counted as fresh.
export const getNewExternalConnections = (
  connections: ExternalConnection[],
  trackedIds: ID[] | null,
): NewExternalConnectionsResult => {
  const currentIds = connections.map(({ id }) => id);

  if (trackedIds === null) {
    return { newConnections: [], nextTrackedIds: currentIds };
  }

  const seen = new Set(trackedIds);
  const newConnections = connections.filter(({ id }) => !seen.has(id));
  const nextTrackedIds = [...trackedIds, ...newConnections.map(({ id }) => id)];

  return { newConnections, nextTrackedIds };
};
